import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DevTool } from "@hookform/devtools"
import schema from "./Validation"
import { Grid } from "@mui/material"
import { AcademicLevel, Campus, Consentement, RequiredFields, Submit } from "components"
import { Email, InputText, PhoneNumber } from "components/fields"
import { useForms, useSalesforce, useUrlReturn } from "hooks"
import { defaultValues, getAcademicLevels } from "services"
import MentionsLegales from "components/MentionsLegales"

const Form = () => {
  const { recordTypeId, salesforce, setError, setOpenSnackbar } = useForms()
    const { url } = useUrlReturn('EDS-DOC')
  // Styles
  // Form
  const methods = useForm({
    defaultValues: {
      lead: {
        ...defaultValues,
        PostalCode: '',
        Salutation: ''
      }
    },
    resolver: yupResolver(schema)
  })
  const { control } = methods
  // State
  // Submit form
  const onSubmit = async data => {
    setOpenSnackbar(false)
    const lead = data.lead
    const campus = lead.Campus__c
    const defaultDataLead = {
      Company: lead.FirstName + ' ' + lead.LastName,
      Is_From_Web__c: true,
      LeadSource: 'Demande de doc',
      RecordTypeId: recordTypeId
    }
    const finalLead = {...lead, ...defaultDataLead}
    try {
      await salesforce.createLead(finalLead)
      document.location.href=`${url}?campus=${campus}`
    } catch (error) {
      setError('Une erreur est survenue lors de la soumission du formulaire', error)
    }
  }
  // Watch
  // useEffect
  useSalesforce('EPITECH DIGITAL', true)

  return (
    <FormProvider {...methods}>
      <DevTool control={control} />
      <Grid container spacing={2}>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Prénom" name="lead.FirstName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Nom" name="lead.LastName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Email control={control} label="Adresse e-mail" name="lead.Email" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <PhoneNumber control={control} name="lead.MobilePhone" label="Téléphone" required />
        </Grid>
        <Grid item sm={4} xs={12}>
          <InputText control={control} label="Code postal" name="lead.PostalCode" required />
        </Grid>
        <Grid item sm={4} xs={12}>
          <AcademicLevel options={getAcademicLevels('Epitech Digital')} section={false} specialites={false} />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Campus label="Campus souhaité" />
        </Grid>
        <Consentement form="Documentation" school="Epitech Digital" />
        <Submit onSubmit={onSubmit} />
        <RequiredFields />
        <MentionsLegales form="Documentation" school="Epitech Digital" />
      </Grid>
    </FormProvider>
  )
}

export default Form
